// extracted by mini-css-extract-plugin
export default {"button":"GenerateSkillsCommands_button__lS3Rl"};